"use strict";

exports.__esModule = true;
exports.default = _default;

function _default(result, options) {
  var message = result.errors[0].message;
  var error = new Error(message);
  error.isApolloError = true;
  error.errors = result.errors;
  error.result = result;
  error.options = options;
  throw error;
}